import Konva from 'konva';
import { _registerNode } from 'konva/lib/Global';

class LineTransformer extends Konva.Group {
  constructor(attrs){
    super(attrs)
    this.className = this.constructor.name
  }

  getNode(){
    return this.children[0];
  }

  // Konva prevents shape that are not groups or basic ones to be added to the layer
  // with this we'd allow it.
  getType(){
    return 'Group';
  }

  removeAnchors(){
    if(this.children.length > 1){
      // Arrow, Line and Highlighter don't make use of Konva built in transformer object,
      // instead is a group we create where we can put anchors for resizing
      // The line is included in the group, just destroy its anchors
      // needs to happen in this order, destroying a children removes them from the array,
      // causing the dimmensions to change and index 2 not working.
      this.children[2].destroy();
      this.children[1].destroy();
    }
  }
}

// Need to register the node to Konva, so it detects it as a valid shape
// and things like Konva.Node.crate({ className: 'LineTransformer }) works
// which is what we do when we paste in annotations.
LineTransformer.prototype.nodeType = 'LineTransformer';
_registerNode(LineTransformer);